/**
 * Asynchronously loads the component for DealerSettingsPage
 */

import { lazyLoad } from 'utils/loadable';

export const DealerSettingsPage = lazyLoad(
  () => import('./index'),
  module => module.DealerSettingsPage,
);
